import { render, staticRenderFns } from "./SignatureImage.vue?vue&type=template&id=e050c178&scoped=true"
import script from "./SignatureImage.vue?vue&type=script&lang=js"
export * from "./SignatureImage.vue?vue&type=script&lang=js"
import style0 from "./SignatureImage.vue?vue&type=style&index=0&id=e050c178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e050c178",
  null
  
)

export default component.exports